import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { navigate } from '../actions/core.actions';
import { RootState } from '../reducers';
import { RoutingPathResolver } from '../app-routing-path-resolver';

@Injectable({ providedIn: 'root' })
export class AccountMenuService {
  menus = [
    { key: 'admin/accounts', icon: 'group', label: 'ユーザー', isActive: false },
    { key: 'admin/schools', icon: 'school', label: '学校', isActive: false },
    { key: 'admin/jukus', icon: 'domain', label: '塾・予備校', isActive: false },
    { key: 'admin/daigakus', icon: 'location_city', label: '大学', isActive: false }
  ];

  constructor(private router: Router, private store: Store<RootState>) {
    // ルート変更を監視して、メニューの有効化を設定する
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.setActiveByUrl(event.urlAfterRedirects);
    });
  }

  setActiveByUrl(url: string) {
    // 有効化されているメニューを設定する
    this.menus.forEach(menu => (menu.isActive = url.includes(menu.key)));
  }

  menuClickHandler(key: string) {
    switch (key) {
      case 'admin/accounts':
        this.store.dispatch(navigate({ url: RoutingPathResolver.resolveAccounts() }));
        break;
      case 'admin/schools':
        this.store.dispatch(navigate({ url: RoutingPathResolver.resolveSchools() }));
        break;
      case 'admin/jukus':
        this.store.dispatch(navigate({ url: RoutingPathResolver.resolveJukus() }));
        break;
      case 'admin/daigakus':
        this.store.dispatch(navigate({ url: RoutingPathResolver.resolveDaigakus() }));
        break;
    }
  }
}
